<template>
  <el-form :model="lineForm" :rules="rules" ref="lineForm" label-width="120px">
    <el-form-item label="业务线名称" prop="name">
      <el-input v-model="lineForm.name" placeholder="请输入业务线名称"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm('lineForm')">立即创建</el-button>
      <el-button @click="resetForm('lineForm')">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { lineApi } from '@/api/index';
export default {
  data () {
    return {
      lineForm: {
        name: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入业务线名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await lineApi.newLine(this.lineForm);
          if (res.code) {
            this.$message.success('创建成功！');
            this.$emit('close');
            this.$emit('getLineList');
          } else {
            this.$message.error(res.message);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style>
</style>